import { render, staticRenderFns } from "./QSummitHomePageRoadmapDesktop.vue?vue&type=template&id=9f8c03a6&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports